/* Open external call-to-action and primary navigation links in a new tab */
(function () {
    const selector = [
        '.kg-cta-button[href]',
        '.kg-cta-image-container > a[href]',
        '#gh-navigation-menu .nav a[href]'
    ].join(', ');

    document.querySelectorAll(selector).forEach(function (link) {
        let url;

        try {
            url = new URL(link.getAttribute('href'), window.location.href);
        } catch (error) {
            return;
        }

        const isWebLink = url.protocol === 'http:' || url.protocol === 'https:';
        const isExternal = url.origin !== window.location.origin;

        if (!isWebLink || !isExternal) return;

        const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');

        link.setAttribute('target', '_blank');
        link.setAttribute('rel', Array.from(rel).join(' '));
    });
})();
